import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';
import { Session, Api } from '../../services/index';
import { Subscription } from 'rxjs/Subscription';

declare var TB: any;
@Component({
    selector: 'video-session',
    templateUrl: 'video-session.html'
})

export class VideoSession implements OnDestroy, OnInit {
    exam: any;
    examEnded: boolean;
    poller: any = null;
    otSession: any;

    @Output() onClose: EventEmitter<any> = new EventEmitter();

    constructor(public api: Api, 
                public session: Session) {
    }

    ngOnInit() {
        this.exam = this.session.examIntake;
        console.log("ngInit starting video");
        this.startVideo(this.exam.videoSessionId, this.exam.videoTokenId, 'videoContainer', this.exam.videoProjectId);
    }

    ngOnDestroy() {
        this.otSession.off('streamCreated');
        this.otSession.off('sessionConnected');
        this.otSession.disconnect();
    }

    startVideo(videoSessionId, videoTokenId, videoFrame, videoProjectId) {
        TB = window['OT'];
        this.otSession = TB.initSession(videoProjectId, videoSessionId);
        let _self = this;
        this.otSession.on('streamCreated', function (event) {
            _self.otSession.subscribe(event.stream, 'subscriber', {
                insertMode: 'append',
                width: '100%',
                height: '100%',
                subscribeToAudio: true
            });
            console.log("The session created.");
        });
        this.otSession.on("sessionDisconnected", function (event) {
            console.log("The session disconnected. " + event.reason);
        });
        this.otSession.connect(videoTokenId, function (error) {
            if (!error) {
                let publisherProperties = {
                    width: '100%',
                    height: '100%'
                };
                let publisher = TB.initPublisher('publisher', publisherProperties);

                _self.otSession.publish(publisher);
                console.log("The session published.");
            } else {
            }
        });
    }
}

